import React, { useEffect } from "react";

import CategoryPublisherList from "./CategoryPublisherList";
import GenerateDigestButton from "./GenerateDigestButton";
import { useUserContext } from "../UserProvider";
import { useUpgradePlan } from "./UpgradePlanProvider";
import Plan from "./Plan";

// CSS for fade-in animation
const fadeInAnimation = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fade-in {
    animation: fadeIn 0.3s ease-out forwards;
  }
`;
const style = document.createElement("style");
style.textContent = fadeInAnimation;
document.head.appendChild(style);
const LeftSidebar = ({
  userData,
  reloadUser,
  isLoading,
  setIsLoading,
  handleGenerateSummary,
}) => {
  const { counts } = useUserContext();
  const { showPlanUpgrade } = useUpgradePlan();

  useEffect(() => {
    if (counts.user_summary) {
      setIsLoading(false);
    }
  }, [counts.user_summary]);

  return (
    <div className="flex flex-col h-full">
      <div className="flex-grow overflow-auto">
        <div className="fixed top-0 left-0 right-0 z-[1000] bg-white border-b border-b-gray-200">
          <GenerateDigestButton
            onClick={handleGenerateSummary}
            isLoading={isLoading}
          />
        </div>
        <div className="pt-[68px]">
          <CategoryPublisherList
            isLoading={isLoading}
          />
        </div>
      </div>
      <div className="sticky bottom-0 flex justify-between items-center p-4 bg-gray-50 border-t border-gray-200 h-16">
        <Plan />
      </div>
    </div>
  );
};

export default LeftSidebar;
